import type { DirectoryNodeKind } from './types';

const KINDS_WITHOUT_PERMISSIONS = new Set<DirectoryNodeKind>(['record', 'generatedRecord']);

export interface DirectoryPermissionAccessInput {
  isSuperuser: boolean;
  hasEditPermission: boolean;
  nodeKind: DirectoryNodeKind | null;
  nodeSuperadminRestricted: boolean;
}

export interface DirectoryPermissionAccess {
  canViewPermissionsTab: boolean;
  canToggleSuperadmin: boolean;
}

export function resolveDirectoryPermissionAccess(
  input: DirectoryPermissionAccessInput
): DirectoryPermissionAccess {
  const { isSuperuser, hasEditPermission, nodeKind, nodeSuperadminRestricted } = input;

  const canManage = isSuperuser || (hasEditPermission && !nodeSuperadminRestricted);
  const canViewPermissionsTab =
    nodeKind !== null && !KINDS_WITHOUT_PERMISSIONS.has(nodeKind) && canManage;

  return {
    canViewPermissionsTab,
    canToggleSuperadmin: isSuperuser,
  };
}
